// extracted by mini-css-extract-plugin
module.exports = {"textArea":"TextArea_textArea__tweok","error":"TextArea_error__9sM70"};